import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import quizListModel from "@/models/survey-quiz/quiz-list";
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useDate from "@/utils/hooks/useDate";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useQuizList() {
  const { getPermissionModule } = usePermissionByAccount()

  const { fetchQuizListModel, deleteQuiz, toggleStatus } = quizListModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const { resolveDateWithSeperator, resolveTime } = useDate();

  const loading = reactive({
    tableData: false,
  });

  const optionData = reactive({
    quizList: [],
  });

  const fields = [
    { key: "seq", label: "No." },
    { key: "cover_image_url", label: "Image" },
    { key: "title_name", label: "Tiltle Name" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "updatedtime", label: "Last Update" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const quizListTable = reactive({
    payload: [],
  });

  const fetchQuizList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchQuizListModel.payload.Page = pagination.currentPage;
    fetchQuizListModel.payload.Limit = pagination.perPage;
    fetchQuizListModel.payload.Filters = filters;
    fetchQuizListModel.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchQuizListModel)
      .then((response) => {
        quizListTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const onRemoveQuiz = (item) => {
    openWarningModal(
      "ลบ Quiz",
      `ต้องการลบรายการ ${item.title_name} นี้หรือไม่ ?`,
      () => {
        deleteQuiz.payload.GroupId = item.quiz_groupid;

        store
          .dispatch("api/apiRequest", deleteQuiz)
          .then((response) => {
            openSuccessModal(
              "ลบรายการสำเร็จ !",
              null,
              "ตกลง",
              () => {
                fetchQuizList();
              },
              () => {}
            );
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  const onToggleStatus = (status, groupQuiz) => {
    loading.tableData = true;
    toggleStatus.payload.GroupId = groupQuiz.quiz_groupid;
    toggleStatus.payload.Status_Group = status ? 1 : 0;
    store
      .dispatch("api/apiRequest", toggleStatus)
      .then((response) => {
        fetchQuizList();
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const setDefaultActiveTab = () => {
    localStorage.removeItem("activeTab");
  };

  const onCreateQuiz = () => {
    setDefaultActiveTab();
    router.push("/quiz/create");
  };

  const onOpenDashboard = (item) => {
    router.push({
      path: `/quiz/dashborad/${item.quiz.quiz_groupid}`,
    });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchQuizList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchQuizList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchQuizList();
  });

  return {
    loading,
    optionData,
    fields,
    pagination,
    onPageChange,
    onFilterEntity,
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
    quizListTable,
    onCreateQuiz,
    onRemoveQuiz,
    resolveDateWithSeperator,
    resolveTime,
    onToggleStatus,
    fetchQuizList,
    onOpenDashboard,
    getPermissionModule
  };
}
